module.exports = __webpack_public_path__ + "img/resultsicon.53aba75f.svg";